import { create } from 'zustand';
import { allowNextUpdateApi } from '../../../../../api/api';

const INITIAL_STATE = {
  isOpen: false,
  deviceId: null,
  serialNumber: '',
  allowed: false,
  loading: false,
  error: '',
};

export const useFirmwareUpdateStore = create((set, get) => ({
  ...INITIAL_STATE,

  open: (device) => {
    if (!device?.id) return;
    set({
      ...INITIAL_STATE,
      isOpen: true,
      deviceId: device.id,
      serialNumber: device.serial_number ?? '',
      allowed: Boolean(device.is_next_update_allowed),
    });
  },

  close: () => set({ ...INITIAL_STATE }),

  toggleAllowed: async (value) => {
    const { deviceId, allowed: previousAllowed } = get();
    if (!deviceId) return;

    set({ allowed: value, loading: true, error: '' });

    try {
      await allowNextUpdateApi({
        deviceId,
        allowed: value,
      });
    } catch (err) {
      const message = err?.response?.data?.error ?? err?.message ?? 'Не удалось изменить разрешение обновления';
      if (get().deviceId !== deviceId) return;
      set({ allowed: previousAllowed, error: message });
    } finally {
      if (get().deviceId === deviceId) set({ loading: false });
    }
  },
}));
